/*
 * Constants mirrored from the mobile app's `@app/utils/commons` so the ported
 * rate engine reads identically to its source.
 */

export const TIME_ZONE = "America/New_York";

export const DEFAULT_DATE_FORMAT = "YYYY-MM-DD HH:mm:ss";

export const DATE_KEY_FORMAT = "YYYY-MM-DD";

export const TimesheetStatus = {
  NEW: { key: "NEW", mstr_key: 1, label: "New", value: "new" },
  ATTESTATION_REQUIRED: {
    key: "ATTESTATION_REQUIRED",
    mstr_key: 8,
    label: "Attestation Required",
    value: "attestation_required",
  },
  APPROVAL_IN_PROCESS: {
    key: "APPROVAL_IN_PROCESS",
    mstr_key: 2,
    label: "Approval In Process",
    value: "approval_in_process",
  },
  REJECTED: { key: "REJECTED", mstr_key: 3, label: "Rejected", value: "rejected" },
  APPROVED: { key: "APPROVED", mstr_key: 4, label: "Approved", value: "approved" },
  HOLD: { key: "HOLD", mstr_key: 9, label: "Hold", value: "hold" },
  PENDING_COMP_ADMIN_REVIEW: {
    key: "PENDING_COMP_ADMIN_REVIEW",
    mstr_key: 5,
    label: "Comp Admin Review",
    value: "pending_comp_admin_review",
  },
  READY_FOR_PAYROLL_PROCESSING: {
    key: "READY_FOR_PAYROLL_PROCESSING",
    mstr_key: 6,
    label: "Ready for Payroll Processing",
    value: "ready_for_payroll_processing",
  },
  SENT_TO_PAYROLL: {
    key: "SENT_TO_PAYROLL",
    mstr_key: 7,
    label: "Sent to Payfile",
    value: "sent_to_payroll",
  },
};

// Mirrors mobile `capitalizeFirstLetter`: capitalises each space-separated word
// and lowercases the remainder ("bi-weekly" -> "Bi-weekly").
export const capitalizeFirstLetter = (str) => {
  if (typeof str !== "string" || str.length === 0) return str;
  return str
    .split(" ")
    .map((word) =>
      word.length === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    )
    .join(" ");
};

// Mirrors mobile `parseTimeInput`: lenient "HH:MM" / "HHMM" / "H" parsing.
export const parseTimeInput = (raw) => {
  const value = String(raw ?? "").trim();
  if (!value) return { hours: 0, minutes: 0 };

  if (value.includes(":")) {
    const [h, m] = value.split(":");
    return { hours: Number(h) || 0, minutes: Number(m) || 0 };
  }
  if (value.length > 2) {
    return { hours: Number(value.slice(0, -2)) || 0, minutes: Number(value.slice(-2)) || 0 };
  }
  return { hours: Number(value) || 0, minutes: 0 };
};

// Mirrors mobile `formatTimeDisplay`.
export const formatTimeDisplay = (hours, minutes) =>
  `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;

// Mirrors mobile `formatDuration`.
export const formatDuration = (hours, minutes) =>
  `${String(hours).padStart(1, "0")}h ${String(minutes).padStart(2, "0")}m`;

// Mirrors mobile `formatAmount` called without a metric type.
export const formatAmount = (value) =>
  Number(value || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const formatFileSize = (sizeInBytes) => {
  const bytes = Number(sizeInBytes) || 0;
  if (bytes < 1024) return `${bytes} Bytes`;
  if (bytes < 1048576) return `${(bytes / 1024).toFixed(2)} KB`;
  return `${(bytes / 1048576).toFixed(2)} MB`;
};
